export default __webpack_public_path__ + "static/media/add.2f0f2bee.svg";